import { Badge, CurrencyDisplay } from "../../../../../components";
import { ISingleTransferViewProps } from "./SingleBankTransferForm";

export const TransferFeeAndRateDisplay = ({
  // fees & rates
  destinationCountryIsNotNigeria,
  sourceCurrency,
  isLoadingTransferFee,
  isSuccessTransferFee,
  swAppTransferFee,
  isLoadingTransferRate,
  isSuccessTransferRate,
  swAppTransferRate,

  formValues,
}: ISingleTransferViewProps) => {
  const currencyIsNotNaira = formValues.currency !== "NGN";

  return (
    <Badge
      statusColor="warning"
      title="Transfer Fees & Rates"
      className="flex-box"
      contentContainerClassName="flex-box"
      hideIndicator
      text={
        <div className="flex-box">
          <strong className="text-success flex-container justify-content--center pt-5">
            TRANSFER FEES {destinationCountryIsNotNigeria ? "& RATES" : ""}
          </strong>
          <hr />

          <div className="fee-viewer">
            <div className="flex-container align-items--center">
              <div className="flex-box align-text--right mr-5">Fee:</div>

              <div className="flex-box flex-1_5">
                {
                  <CurrencyDisplay
                    showSkeleton={isLoadingTransferFee}
                    amount={swAppTransferFee || 0}
                    currencyOrSymbol={formValues.currency}
                  />
                }
              </div>
            </div>
          </div>

          {destinationCountryIsNotNigeria /* && swAppTransferRate && swAppTransferRate !== 1*/ ? (
            <div className="rates-container flex-container col">
              {/* Conversion Rate */}
              <div className="flex-container flex-box mt-3 align-items--center">
                <div className="flex-box align-text--right mr-5">Rate:</div>

                <div className="flex-box flex-1_5">
                  <CurrencyDisplay
                    showSkeleton={isLoadingTransferRate}
                    amount={swAppTransferRate?.rate || 0}
                    currencyOrSymbol={sourceCurrency}
                  />
                </div>
              </div>

              {/* Amount Deducted From Source Currency Wallet */}
              <div className="flex-container flex-box mt-3 align-items--center">
                <div className="flex-box align-text--right mr-5">Sent:</div>

                <div className="flex-box flex-1_5">
                  <CurrencyDisplay
                    showSkeleton={isLoadingTransferRate}
                    amount={swAppTransferRate?.source.amount || 0}
                    currencyOrSymbol={sourceCurrency}
                  />
                </div>
              </div>

              {/* Amount Received By Beneficiary */}
              <div className="flex-container flex-box mt-3 align-items--center">
                <div className="flex-box align-text--right mr-5">Received:</div>

                <div className="flex-box flex-1_5">
                  <CurrencyDisplay
                    showSkeleton={isLoadingTransferRate}
                    amount={swAppTransferRate?.destination.amount || 0}
                    currencyOrSymbol={formValues.currency}
                  />
                </div>
              </div>
            </div>
          ) : null}

          {/* <hr /> */}
          {!(destinationCountryIsNotNigeria || currencyIsNotNaira) ? null : (
            <strong className="expectation-managment--text text-danger flex-container justify-content--center pt-5">
              NOTE: International transfers may take up to 24-72 hours before
              confirmation.
            </strong>
          )}
        </div>
      }
    />
  );
};
